
export const ProjectItems = [
    {
        name: "Fansite - blink-182",
        category: "Web Design",
        image: "../Images/blink182 fansite.png",
        description: "This is a description of the project I have worked on. Check out the project page for more details!"

    },

    { name: "C# Chess Game", category: "C#", image: "../Images/csharp project template.png", description: "This is a description of the project I have worked on. Check out the project page for more details!" },

    { name: "React Component Library", category: "Web Design", image: "../Images/reactlib.png", description: "A collection of the React components I have created during the time I have spent learning the React framework. These components are used in most of my React projects." },

    { name: "Creative Catalog", category: "Web Design", image: "../Images/creativecatalogue.png", description: "A collection of different webpages that I have built to showcase my mastery of CSS, Javascript, REACT JS, and HTML5. " }



]